import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';

const Products = () => {
  const containerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const products = [
    { id: 1, title: t('products.product1.title'), description: t('products.product1.description'), price: 700, image: 'https://images.unsplash.com/photo-1712924833046-1c54abac2840?w=600&auto=format&fit=crop' },
    { id: 2, title: t('products.product2.title'), description: t('products.product2.description'), price: 650, image: 'https://customer-assets.emergentagent.com/job_modular-expert/artifacts/gg87sosz_housingg.jpg' },
    { id: 3, title: t('products.product3.title'), description: t('products.product3.description'), price: 850, image: 'https://customer-assets.emergentagent.com/job_modular-expert/artifacts/uwbbzxnj_edificio.png' },
    { id: 4, title: t('products.product4.title'), description: t('products.product4.description'), price: 450, image: 'https://customer-assets.emergentagent.com/job_modular-expert/artifacts/6739e1ij_vacam.png' },
    { id: 5, title: t('products.product5.title'), description: t('products.product5.description'), price: 900, image: 'https://customer-assets.emergentagent.com/job_modular-expert/artifacts/yuwfdajb_hspital.png' },
    { id: 6, title: t('products.product6.title'), description: t('products.product6.description'), price: 990, image: 'https://customer-assets.emergentagent.com/job_modular-expert/artifacts/s1xn598b_Captura%20de%20pantalla%202026-02-04%20a%20la%28s%29%2010.59.11%E2%80%AFp.%C2%A0m..png' }
  ];

  return (
    <section ref={containerRef} className="py-24 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-600 text-sm font-semibold uppercase tracking-wider">{t('products.badge')}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-neutral-900 mt-4">{t('products.title')}</h2>
          <p className="text-neutral-600 mt-4 max-w-2xl mx-auto">{t('products.subtitle')}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div key={product.id}
              className={`group relative bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}>
              <div className="relative h-56 overflow-hidden">
                <img src={product.image} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-neutral-900/60 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <span className="text-white/60 text-sm">{t('products.from')}</span>
                  <span className="text-white text-3xl font-bold ml-1">${product.price}</span>
                  <span className="text-white/80 text-sm">/m²</span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-neutral-900 mb-2 group-hover:text-red-600 transition-colors">{product.title}</h3>
                <p className="text-neutral-600 text-sm leading-relaxed">{product.description}</p>
              </div>
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-red-500 rounded-2xl transition-colors duration-300 pointer-events-none" />
            </div>
          ))}
        </div>
        <p className="text-center text-neutral-500 text-sm mt-12">{t('products.disclaimer')}</p>
      </div>
    </section>
  );
};

export default Products;
